import { Gender } from './gender.enum';

export class Individual {
  public ind_first_name: string = undefined;
  public ind_mid_name: string = undefined;
  public ind_last_name: string = undefined;
  public ind_badge_name: string = undefined;
  public ind_full_name_cp: string = undefined;
  public ind_dob: Date = undefined;
  public ind_gender: Gender = undefined;
  public ind_yes_hot_stone_practice_flag_ext: boolean = undefined;
  public ind_yes_hot_stone_practice_date_ext: Date = undefined;
  public ind_no_hot_stone_practice_flag_ext: boolean = undefined;
  public ind_no_hot_stone_practice_date_ext: Date = undefined;
  public ind_hot_stone_do_not_agree_flag_ext: boolean = undefined;
  public ind_hot_stone_do_not_agree_date_ext: Date = undefined;
  public ind_hot_stone_agreement_flag_ext: boolean = undefined;
  public ind_hot_stone_agreement_date_ext: Date = undefined;
  public ind_hot_stone_video_flag_ext: boolean = undefined;
  public ind_hot_stone_video_date_ext: Date = undefined;
  public ind_hot_stone_video_do_not_agree_flag_ext: boolean = undefined;
  public ind_hot_stone_video_do_not_agree_date_ext: Date = undefined;
  public ind_mblex_date_ext: Date = undefined;
  public cst_key: string = undefined;
  public cst_recno: number = undefined;
  public cst_new_password: string = undefined;
  public cst_new_password_confirm: string = undefined;
  public cst_org_name_dn: string = undefined;
  public cst_member_flag: boolean = undefined;
  public cxa_key: string = undefined;
  public cst_cxa_billing_key: string = undefined;
  public cxa_mailing_label: string = undefined;
  public eml_address: string = undefined;
  public adr_line1: string = undefined;
  public adr_city: string;
  public adr_state: string;
  public adr_post_code: string;
  public adr_country: string = undefined;

  public ind_token: string = undefined;
  public cst_sms_opt: string = undefined;
  public BPPIneligible: boolean | string = false;

  // Referral / Affinity columns
  public cst_src_key: string = undefined;
  public cst_src_option_select_ext: string = undefined;
  public cst_src_referral_member_first_name_ext: string = undefined;
  public cst_src_referral_member_last_name_ext: string = undefined;
  public cst_src_referral_cst_recno_ext: number = undefined;
  public cst_src_specify_other_ext: string = undefined;

  public hit_student_portal: boolean = false;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'ind_dob':
            case 'ind_yes_hot_stone_practice_date_ext':
            case 'ind_no_hot_stone_practice_date_ext':
            case 'ind_mblex_date_ext':
              let date = source[key] || null;
              if (date) {
                if (typeof date === 'string') {
                  date = new Date(date);
                } else if ('date' in date) {
                  date = new Date(date.date);
                }

                if (date instanceof Date && !isNaN(date.valueOf())) {
                  this[<any>key] = date;
                }
              }
            break;
            case 'cst_recno':
            case 'cst_src_referral_cst_recno_ext':
              const cst_recno = source[key] || null;
              const k: 'cst_recno' | 'cst_src_referral_cst_recno_ext' = <any>key;
              if (cst_recno) {
                this[k] = parseInt(cst_recno, 10) || null;
              }
            break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
